import TokenHandler from './services/tokenHandler';
import LateRequest from './services/lateRequest';
import AccessHandler from './services/accessHandler';
import LoginEvent from './services/loginEvent';
import ResetHandler from './services/resetHandler';
import LoginForm from './organisms/o-login-form';
import ResetForm from "./organisms/o-reset-form";
import LoginInfo from './organisms/o-login-info';
import LoginPage from "./pages/p-login";
import ExternalLoginPage from './pages/p-external';
import routing from "./login.routes";
import Logo from "./organisms/o-logo";

export default angular.module('app.login', [])
    .config(routing)
    .component('pLogin', new LoginPage)
    .component('externalLogin', new ExternalLoginPage)
    .component('oLoginForm', new LoginForm)
    .component('oResetForm', new ResetForm)
    .component('oLoginInfo', new LoginInfo)
    .component('oLogo', new Logo)
    .service('TokenHandler', TokenHandler)
    .service('LateRequest', LateRequest)
    .service('AccessHandler', AccessHandler)
    .service('LoginEvent', LoginEvent)
    .service('ResetHandler', ResetHandler)
    .name;

